import React from 'react';
import '../MobileInfo.css';

const MobileTaxiInfo = ({ driver, tripDetails, status }) => {
  // Sort trip details by location type (pickup first, dropoff second)
  const sortedTripDetails = [...tripDetails].sort((a, b) => {
    if (a.locationType === 'pickup') return -1;
    if (b.locationType === 'pickup') return 1;
    return 0;
  });

  // Format date function
  const formatDateTime = (dateString) => {
    if (!dateString) return 'Not available';
    
    const date = new Date(dateString);
    return `${date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })} ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}(GMT+3)`;
  };

  return (
    <div className="mobile-taxi-info">
      <div className="mobile-trip-details">
        <h3 className="mobile-section-title">TRIP DETAILS</h3>
        <div className="mobile-locations-container">
          {sortedTripDetails.map((location, index) => (
            <div className="mobile-location-item" key={index}>
              <div className={`mobile-location-marker ${location.locationType === 'pickup' ? 'mobile-pickup-dot' : 'mobile-dropoff-dot'}`}></div>
              <div className="mobile-location-info">
                <h4 className="mobile-location-title">{location.locationType === 'pickup' ? 'PICKUP' : 'DROPOFF'}</h4>
                <p className="mobile-location-address">{location.address}</p>
                <div className="mobile-location-time">
                  {formatDateTime(location.arrived_at)}
                </div>
              </div>
            </div>
          ))}
          {/* Connector line between pickup and dropoff */}
          <div className="mobile-connector-line"></div>
        </div>
      </div>
      
      <div className="mobile-section-divider"></div>

      <div className="mobile-captain-info">
        <h3 className="mobile-section-title">CAPTAIN INFORMATION</h3>
        
        {/* Captain Avatar and Name */}
        <div className="mobile-captain-profile">
          <div className="mobile-avatar-container">
            {driver.avatar ? (
              <img 
                src={driver.avatar} 
                alt={driver.name} 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/70x70?text=Driver';
                }}
              />
            ) : (
              <img src="https://via.placeholder.com/70x70?text=Driver" alt="Driver" />
            )}
          </div>
          <div className="mobile-captain-name">
            <p className="mobile-info-label">CAPTAIN</p>
            <p className="mobile-info-value">{driver.name}</p>
          </div>
        </div>

        {/* Phone Number with Call Button */}
        <div className="mobile-info-row">
          <div className="mobile-info-icon">
            <span className="fas fa-phone"></span>
          </div>
          <div className="mobile-info-content">
            <p className="mobile-info-label">PHONE</p>
            <p className="mobile-info-value">{driver.phone}</p>
            <a href={`tel:${driver.phone}`} className="mobile-call-button">
              <span className="fas fa-phone"></span>
            </a>
          </div>
        </div>

        {/* Vehicle Information */}
        <div className="mobile-info-row">
          <div className="mobile-info-icon">
            <span className="fas fa-car"></span>
          </div>
          <div className="mobile-info-content">
            <p className="mobile-info-label">{driver.vehicle_model}</p>
            <p className="mobile-info-value">{driver.vehicle_model_details}</p>
            <div className="mobile-plate-number">{driver.vehicle_plate}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileTaxiInfo;
